import { createBrowserRouter } from 'react-router';
import { LandingPage } from '@/features/landing/LandingPage';
import { StudioRoot } from '@/features/studio/StudioRoot';
import { ClientLayout } from '@/features/studio/ClientLayout';
import { NotFoundPage } from '@/features/studio/NotFoundPage';
import { HomePage } from '@/features/home/HomePage';
import { ServicesPage } from '@/features/services/ServicesPage';
import { MyBookingsPage } from '@/features/my/MyBookingsPage';
import { AssistantPage } from '@/features/assistant/AssistantPage';
import { InstallPage } from '@/features/install/InstallPage';
import { RouteError } from './RouteError';

export const router = createBrowserRouter([
  { path: '/', element: <LandingPage />, errorElement: <RouteError /> },
  {
    path: '/s/:slug',
    element: <StudioRoot />,
    errorElement: <RouteError />,
    children: [
      {
        element: <ClientLayout />,
        children: [
          { index: true, element: <HomePage /> },
          { path: 'services', element: <ServicesPage /> },
          { path: 'my', element: <MyBookingsPage /> },
          { path: 'assistant', element: <AssistantPage /> },
          { path: 'app', element: <InstallPage /> },
        ],
      },
      {
        // The owner cabinet is a separate chunk: customers never download it.
        path: 'owner/*',
        lazy: async () => {
          const { OwnerApp } = await import('@/features/owner/OwnerApp');
          return { Component: OwnerApp };
        },
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
]);
